var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-scrollbar",class:_vm.$style[`cc-side-effect-summary`]},[_c('div',{class:_vm.$style[`cc-side-effect-summary-wrap`]},[_c('EffectAnalysis')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }